import { z } from 'zod';
/**
 * Strada Response v1 Configuration Validator
 * Validates response configuration for early returns in synchronous workflows
 */
export const Strada_Response_1_ConfigValidator = z.object({
    response: z.record(z.string(), z.any()).optional()
});
//# sourceMappingURL=strada-response-1.js.map